export const Languages = [
    { languageCode: "en", languageFlag: "🇬🇧", languagePath: "/" }, // English
    { languageCode: "it", languageFlag: "🇮🇹", languagePath: "/it" }, // Italian
    { languageCode: "es", languageFlag: "🇪🇸", languagePath: "/es" }, // Spanish
    { languageCode: "pt", languageFlag: "🇵🇹", languagePath: "/pt" }, // Portuguese
    { languageCode: "fr", languageFlag: "🇫🇷", languagePath: "/fr" }, // French
    { languageCode: "de", languageFlag: "🇩🇪", languagePath: "/de" }, // German
    { languageCode: "hi", languageFlag: "🇮🇳", languagePath: "/hi" }, // Hindi
    { languageCode: "cs", languageFlag: "🇨🇿", languagePath: "/cs" }, // Czech
    { languageCode: "nl", languageFlag: "🇳🇱", languagePath: "/nl" }, // Dutch (Netherlands)
    { languageCode: "zh", languageFlag: "🇨🇳", languagePath: "/zh" }  // Chinese
];
    